import {
  Dimensions,
  Modal,
  StyleSheet,
  TouchableOpacity,
  View,
} from "react-native";
import { useEffect, useRef, useState } from "react";
import { web } from "./Platform";
import CustomText from "./CustomText";
import Icon from "react-native-vector-icons/FontAwesome";
import { Separator } from "./accessories";
import { generateBoxShadowStyle } from "./CommonFunctions";
import Footer from "./footer";

const options = [
  { Name: "Compare an Adjustable Rate with a Fixed Rate", type: "aF" },
  { Name: "Blended Rate Analysis", type: "bR" },
  { Name: "Buy vs Rent", type: "rB" },
  { Name: "Affordability", type: "aFF" },
  { Name: "Appreciation", type: "aA" },
  { Name: "Bid Over Asking Price", type: "bOA" },
  { Name: "Payment Calculator", type: "hP" },
];

const CalculatorMenu = ({
  menuNode: MenuNode,
  onPress,
  navigation,
  route,
  setFloatPage,
}) => {
  const { From, LoanId, UserId, type } = route?.params || {};
  const [isOpen, setIsOpen] = useState(false);
  const [navPosition, setNavPosition] = useState({
    top: 0,
    left: 0,
    opacity: 0,
    bottom: 0,
  });
  const isMobileWeb = Dimensions.get("window").width <= 480;
  const rightNavRef = useRef();
  const handleRightNavOpen = () => {
    rightNavRef.current.measure((_fx, _fy, _w, h, _px, py) => {
      setNavPosition({
        ...{
          bottom: 90 || py + (web ? 73 : 50),

          opacity: 1,
        },
        ...(web ? { left: _px - 100 } : {}),
      });
    });
  };
  useEffect(() => {
    rightNavRef?.current?.setNativeProps({
      tabIndex: -1,
    });
  }, [rightNavRef.current]);

  const handleBackAction = () => {
    if (web) setFloatPage(null);
    else
      navigation?.navigate(
        route?.params?.From || From || "DashBoard",
        route?.params
      );
    return true;
  };

  return (
    <>
      <View style={{ backgroundColor: "#fff", flex: 1 }}>
        <TouchableOpacity activeOpacity={1} onPress={handleBackAction}>
          <CustomText
            bold={true}
            style={{ paddingVertical: 10, paddingHorizontal: 10 }}
          >
            {!web ? (
              <>
                <Icon name="angle-left" size={16} /> Back
              </>
            ) : (
              <>
                <Icon size={16} name="close" color="red" /> Close
              </>
            )}
          </CustomText>
        </TouchableOpacity>

        <View style={{ marginHorizontal: 15 }}>
          <CustomText bold={true} style={{ fontSize: 25, marginVertical: 5 }}>
            Calculators
          </CustomText>
          <CustomText style={{ fontSize: 18 }}>
            Here are some helpful calculators.
          </CustomText>

          <Separator />
          <View style={{ marginBottom: 35 }}>
            {options.map((item, index) => {
              return (
                <TouchableOpacity
                  activeOpacity={0.5}
                  onPress={() => {
                    if (web) {
                      setFloatPage({
                        path: "Calculator",
                        option: {
                          From: "CalculatorMenu",
                          type: item["type"],
                          LoanId,
                          style: {
                            minHeight: "75vh",
                          },
                        },
                      });
                    } else {
                      navigation.navigate("Calculator", {
                        From: "CalculatorMenu",
                        type: item["type"],
                        LoanId,
                        style: {
                          width: "60%",
                          minWidth: item["type"] === "bR" ? 900 : 860,
                        },
                      });
                    }
                  }}
                  key={index}
                  style={[
                    {
                      backgroundColor: "#fff",
                      marginBottom: 20,
                      borderRadius: 5,
                      minHeight: 50,
                      paddingHorizontal: 10,
                      shadowColor: "rgba(0, 0, 0, 0.30)",
                      shadowRadius: 10,
                      shadowOpacity: 0.5,
                      justifyContent: "center",
                      alignItems: "center",
                    },
                    !web ? { flexDirection: "row", alignItems: "center" } : {},
                    generateBoxShadowStyle(2, 3, "black", 0.2, 3, 8, "black"),
                  ]}
                >
                  <CustomText style={[styles.calcName]}>
                    {item["Name"]}
                  </CustomText>
                </TouchableOpacity>
              );
            })}
          </View>
        </View>
      </View>
      {(!web || isMobileWeb) && (
        <Footer
          iLoanId={LoanId}
          navigate={navigation?.navigate}
          From={From}
          UserId={UserId}
          setFloatPage={setFloatPage}
        />
      )}
    </>
  );
};

export default CalculatorMenu;

const styles = StyleSheet.create({
  calcName: {
    fontSize: 16,
    marginBottom: 5,
  },
});
